import React, { createContext, Dispatch, FC, SetStateAction, useState } from 'react'

export interface LayoutContextValues {
  hidePencilCaseCompany: boolean
  hidePencilCaseUser: boolean
  hideNotificationCenterCompany: boolean
  changeHidePencilCaseCompany: Dispatch<SetStateAction<boolean>>
  changeHidePencilCaseUser: Dispatch<SetStateAction<boolean>>
  changeHideNotificationCenterCompany: Dispatch<SetStateAction<boolean>>
  changeIsAppIntroRunning: Dispatch<SetStateAction<boolean>>
  changeIsTourRunning: Dispatch<SetStateAction<boolean>>
  isAppIntroRunning: boolean
  isTourRunning: boolean
  playground: boolean
  togglePlayground: Dispatch<SetStateAction<boolean>>
  routerMatch: any
  updateRouterMatch: any
  isAntifraudTourRunning: boolean
  changeIsAntifraudTourRunning: Dispatch<SetStateAction<boolean>>
}

export const LayoutContext = createContext<LayoutContextValues>({} as any)

const useLayoutContext = (): LayoutContextValues => {
  // NOTIFICATION CENTER ·······························································································
  const [hideNotificationCenterCompany, setHideNotificationCenterCompany] = useState(true)

  // PENCIL CASE ·······································································································
  const [hidePencilCaseCompany, setHidePencilCaseCompany] = useState(true)
  const [hidePencilCaseUser, setHidePencilCaseUser] = useState(false)

  // TOUR ··············································································································

  const [isAppIntroRunning, setIsAppIntroRunning] = useState(false)
  const [isTourRunning, setIsTourRunning] = useState(false)
  const [isAntifraudTourRunning, setIsAntifraudTourRunning] = useState(false)

  // PLAYGROUND ········································································································
  const [playground, setPlayground] = useState(true)

  // ROUTER ···············································································································
  const [routerMatch, setRouterMatch] = useState({
    isExact: false,
    params: {},
    path: '/',
    url: '/'
  })
  const updateRouterMatch = value => setRouterMatch(value)

  return {
    changeHideNotificationCenterCompany: setHideNotificationCenterCompany,
    changeHidePencilCaseCompany: setHidePencilCaseCompany,
    changeHidePencilCaseUser: setHidePencilCaseUser,
    changeIsAntifraudTourRunning: setIsAntifraudTourRunning,
    changeIsAppIntroRunning: setIsAppIntroRunning,
    changeIsTourRunning: setIsTourRunning,
    hideNotificationCenterCompany,
    hidePencilCaseCompany,
    hidePencilCaseUser,
    isAntifraudTourRunning,
    isAppIntroRunning,
    isTourRunning,
    playground,
    routerMatch,
    togglePlayground: setPlayground,
    updateRouterMatch
  }
}

export const LayoutContextProvider: FC = ({ children }) => {
  const state = useLayoutContext()

  return <LayoutContext.Provider value={state}>{children}</LayoutContext.Provider>
}
